import { isRequestError } from '~/common/services/requests';
import { ApiErrorPayload } from '../types/ApiErrorPayload';
import { hasErrorsMap } from './hasErrorsMap';

export const isValidationErrorResponse = (err: unknown): boolean =>
  isRequestError<ApiErrorPayload>(err) &&
  err.response?.status === 422 &&
  hasErrorsMap(err.response.data);
